import { APP_BOOTSTRAP_LISTENER, APP_INITIALIZER, ComponentRef, Provider } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GoogleAnalyticsService } from '../google-analytics.service';

export  const GOOGLE_ANALYTICS_ROUTER_INITIALIZER_PROVIDER: Provider = {
    provide: APP_BOOTSTRAP_LISTENER,
    multi: true,
    useFactory: GoogleAnalyticsRouterInitializer,
    deps: [
        GoogleAnalyticsService
    ]
}

export function GoogleAnalyticsRouterInitializer(
    service: GoogleAnalyticsService,
){
    return async (c: ComponentRef<any>) => {
        const router = c.injector.get(Router);
        const subs = router
            .events
            .subscribe(event => {
                if(event instanceof NavigationEnd){
                    service.pageView(event.urlAfterRedirects);
                }
            });
        c.onDestroy(() => subs.unsubscribe());
    }
}